import React from 'react';

const year = new Date().getFullYear();
const Footer = () => {
	return (
		<footer className="main-footer">
			<p>Copyright&copy; <span>{year}</span>. All rights reserved</p>
		</footer>
	)
}

export default Footer;